<template>
  <div style="width:100%;">
    <zcy-site-top  v-on:login-status-change="onLoginchange" v-on:env-success="onEnvloaded"></zcy-site-top>
    <zcy-header></zcy-header>
    <zcy-nav :show-cate="false" :show-border="showBorder"></zcy-nav>
    <slot v-bind:env-href="envHref" v-bind:current-user-identity="currentUserIdentity"></slot>
    <zcy-bottom></zcy-bottom>
    <zcy-copyright></zcy-copyright>
  </div>
</template>

<script>
import SiteTop from 'component/site-top';
import Header from 'component/header';
import Nav from 'component/nav';
import Bottom from 'component/bottom';
import Copyright from 'component/copyright';
export default {
  components: {
    'zcy-site-top': SiteTop,
    'zcy-header': Header,
    'zcy-nav': Nav,
    'zcy-copyright': Copyright,
    'zcy-bottom': Bottom
  },
  props: {
    showBorder: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      envHref: window.envHref,
      currentUserIdentity: window.currentUserIdentity
    };
  },
  methods: {
    onLoginchange () {
      this.currentUserIdentity = window.currentUserIdentity;
      this.$emit('loginChange', {...this.currentUserIdentity});
    },
    onEnvloaded () {
      this.envHref = window.envHref;
    }
  }
};

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layout.vue